import Welcome from './View/Welcome.view';
export default Welcome;
